<template>
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="用户名称">
          <el-input size="small" v-model="searchForm.user_search" placeholder="请输入用户ID或用户名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="年份">
          <el-date-picker v-model="searchForm.year" type="year" value-format="yyyy" placeholder="选择年"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="user_id" label="用户信息" width="150">
            <template slot-scope="{row}">
              <div class="d-c-c gap10">
                <el-avatar size="medium" icon="el-icon-user-solid" :src="row.avatarUrl"></el-avatar>
                <div>
                  <p>昵称【{{ row.nickName }}】</p>
                  <p>ID【{{ row.user_id }}】</p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="data.1" label="1月">
            <template slot-scope="{row}">
              <p>{{ row.text1 }}：{{ row.data[1].PF || 0 }}</p>
              <p v-if="row.text2">{{ row.text2 }}：{{ row.data[1].ER || 0 }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="data.2" label="2月">
            <template slot-scope="{row}">
              <p>{{ row.text1 }}：{{ row.data[2].PF || 0 }}</p>
              <p v-if="row.text2">{{ row.text2 }}：{{ row.data[2].ER || 0 }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="data.3" label="3月">
            <template slot-scope="{row}">
              <p>{{ row.text1 }}：{{ row.data[3].PF || 0 }}</p>
              <p v-if="row.text2">{{ row.text2 }}：{{ row.data[3].ER || 0 }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="data.4" label="4月">
            <template slot-scope="{row}">
              <p>{{ row.text1 }}：{{ row.data[4].PF || 0 }}</p>
              <p v-if="row.text2">{{ row.text2 }}：{{ row.data[4].ER || 0 }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="data.5" label="5月">
            <template slot-scope="{row}">
              <p>{{ row.text1 }}：{{ row.data[5].PF || 0 }}</p>
              <p v-if="row.text2">{{ row.text2 }}：{{ row.data[5].ER || 0 }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="data.6" label="6月">
            <template slot-scope="{row}">
              <p>{{ row.text1 }}：{{ row.data[6].PF || 0 }}</p>
              <p v-if="row.text2">{{ row.text2 }}：{{ row.data[6].ER || 0 }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="data.7" label="7月">
            <template slot-scope="{row}">
              <p>{{ row.text1 }}：{{ row.data[7].PF || 0 }}</p>
              <p v-if="row.text2">{{ row.text2 }}：{{ row.data[7].ER || 0 }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="data.8" label="8月">
            <template slot-scope="{row}">
              <p>{{ row.text1 }}：{{ row.data[8].PF || 0 }}</p>
              <p v-if="row.text2">{{ row.text2 }}：{{ row.data[8].ER || 0 }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="data.9" label="9月">
            <template slot-scope="{row}">
              <p>{{ row.text1 }}：{{ row.data[9].PF || 0 }}</p>
              <p v-if="row.text2">{{ row.text2 }}：{{ row.data[9].ER || 0 }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="data.10" label="10月">
            <template slot-scope="{row}">
              <p>{{ row.text1 }}：{{ row.data[10].PF || 0 }}</p>
              <p v-if="row.text2">{{ row.text2 }}：{{ row.data[10].ER || 0 }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="data.11" label="11月">
            <template slot-scope="{row}">
              <p>{{ row.text1 }}：{{ row.data[11].PF || 0 }}</p>
              <p v-if="row.text2">{{ row.text2 }}：{{ row.data[11].ER || 0 }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="data.12" label="12月">
            <template slot-scope="{row}">
              <p>{{ row.text1 }}：{{ row.data[12].PF || 0 }}</p>
              <p v-if="row.text2">{{ row.text2 }}：{{ row.data[12].ER || 0 }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="data.0" label="年度总奖励">
            <template slot-scope="{row}">
              <p>{{ row.text1 }}：{{ row.data[0].PF || 0 }}</p>
              <p v-if="row.text2">{{ row.text2 }}：{{ row.data[0].ER || 0 }}</p>
            </template>
          </el-table-column>
        </el-table>
        <div class="gray9">PF：个人业绩总额。ER：个人总收益</div>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="paginationObj.page" :page-size="paginationObj.list_rows" layout="total, prev, pager, next, jumper" :total="paginationObj.totalDataNumber"></el-pagination>
    </div>

  </div>
</template>

<script>
import StatisticsApi from '@/api/statistics.js'

export default {
  components: {},
  data() {
    return {
      loading: true,
      tableData: [],
      paginationObj: {
        totalDataNumber: 0,
        page: 1,
        list_rows: 10,
      },
      /*搜索参数*/
      searchForm: {
        user_search: '',
        year: '',
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this
      self.loading = true
      self.paginationObj.page = val
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.paginationObj.list_rows = val
      this.getData()
    },

    /*搜索查询*/
    onSubmit() {
      this.paginationObj.page = 1
      this.getData()
    },

    /*获取数据*/
    getData() {
      let self = this
      self.loading = true
      StatisticsApi.getYearEndMoney(Object.assign({}, self.searchForm, self.paginationObj))
        .then(res => {
          self.tableData = res.data.list.data
          self.paginationObj.totalDataNumber = res.data.list.total
          self.loading = false
        }).catch(error => {
          console.log(error)
          self.loading = false
      })
    },
  },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/statistics/yearendbonus/index.vue